// КОПИ КНОПКИ «SAVE PDF» — строка 67 `3f319875cbb881c89a64cda13df7c7b5`. Подпись — `s985.d1`, сборка и
// отказ — ревью `s986` (тексты дословно оттуда). Сочинять здесь нельзя: правка — только словом web-Claude.

export const PDF_COPY = {
  ready: 'Save PDF',
  building: 'Preparing PDF…',
  error: "Couldn't create the PDF. Try again.",
};

/** Имя файла — как в прообразе, который Кирилл проверял на iPhone (s986 п. 3). */
export const PDF_FILENAME = 'life-map.pdf';
